import { Text, HbTooltip } from '@cdl/heartbeat-react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { intervalSelector } from '../../wave/selectors/wave.selectors';
import { useStrip } from '../hooks/useStrip';
import { squareToPixel } from '../utils/graph.utils';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';
import { BPM, MS } from '../../layout/types/layout-state.type';

export const BeatIntervals: React.FC = () => {
  const showHrInBpm = useSelector(getLayoutValueSelector('showHrInBpm'));
  const { xScale, onset } = useStrip();
  const intervals = useSelector(intervalSelector);
  const textOffset = squareToPixel(0.7);

  return (
    <>
      {intervals.map((interval, i) => (
        <HbTooltip
          hasArrow
          label={`RR (${showHrInBpm === false ? MS : BPM})`}
          key={i}
        >
          <g
            key={interval.timestamp}
            transform={`translate(${xScale(
              interval.timestamp + onset,
            )}, ${textOffset})`}
          >
            <Text as='text' fontWeight='semibold' cursor='default'>
              {Math.round(interval.duration)}
            </Text>
          </g>
        </HbTooltip>
      ))}
    </>
  );
};
